import React from 'react';
import {connect} from 'react-redux';
import './refund.scss';

export const RefundAgreements = () => (
  <>
    <div className="refund-agreement__checkbox">
      <label>
        <input type="checkbox" id="yn0" value="y" name="yn0" />
        &nbsp;결제취소/환불신청 개인정보 수집, 활용 동의서에 동의합니다. (필수)
        <a href="https://legal.kr.riotgames.com/pcb_refund/pi" target="_blank" rel="noopener noreferrer">
          내용확인 &#8599;
        </a>
      </label>
    </div>
    <div className="refund-agreement__checkbox">
      <label>
        <input type="checkbox" id="yn1" value="y" name="yn1" />
        &nbsp;결제취소/환불신청 개인정보 국외 이전에 관한 동의서에 동의합니다. (필수)
        <a href="https://legal.kr.riotgames.com/pcb_refund/external" target="_blank" rel="noopener noreferrer">
          내용확인 &#8599;
        </a>
      </label>
    </div>
  </>
);

export default connect(null)(RefundAgreements);
